/**
 * 役割モード。
 *
 * 開発メモの3ユーザーに対応する。モジュールは共通で、**UI だけを分ける**（docs/04 決定事項）。
 *
 *   パイロット      … 飛行中なので情報は極力少なく。分析結果の要約だけを見せる
 *   クルー          … 分析が主役。「コパイロット」として風を読み、無線で伝える
 *   オーディエンス  … ライブ観戦。帯域を抑えるため更新頻度を落とし、表示も簡素にする
 */

export type ModeId = 'pilot' | 'crew' | 'audience';

export interface Mode {
  id: ModeId;
  label: string;
  description: string;
  /** サーバーへの問い合わせ間隔 [ms]。オーディエンスは負荷軽減のため長くする */
  pollingMs: number;
  /** 航跡を保存・表示するか。チェイスクルー自身の航跡は不要（開発メモ） */
  keepOwnTrack: boolean;
}

export const MODES: Mode[] = [
  {
    id: 'pilot',
    label: 'パイロット',
    description: '飛行中向け。情報を絞り、分析の結論だけを表示する',
    pollingMs: 10000,
    keepOwnTrack: true,
  },
  {
    id: 'crew',
    label: 'クルー',
    description: '分析が主役。風を読んでパイロットへ伝えるための画面',
    pollingMs: 10000,
    keepOwnTrack: false,
  },
  {
    id: 'audience',
    label: 'オーディエンス',
    description: 'ライブ観戦向け。更新頻度を落とし、表示も簡素にする',
    pollingMs: 60000,
    keepOwnTrack: false,
  },
];

export function modeOf(id: ModeId): Mode {
  return MODES.find((m) => m.id === id) ?? MODES[1];
}
